export const filesContainer = {
  display: 'inline-flex',
  width: '31px',
  height: '38px',
  boxSizing: 'border-box',
};
export const dropzoneContainer = {
  flex: '1 1 0%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderWidth: '1px',
  borderRadius: '2px',
  borderColor: 'rgb(238, 238, 238)',
  borderStyle: 'dashed',
  backgroundColor: 'transparent',
  color: 'rgb(189, 189, 189)',
  outline: 'currentcolor none medium',
  transition: 'border 0.24s ease-in-out 0s',
  height: 'auto',
  minHeight: '150px',
  position: 'relative',
  maxWidth: '100%',
};
export const dropzone = {
  flex: '1 1 0%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderWidth: '1px',
  color: 'rgb(189, 189, 189)',
  outline: 'currentcolor none medium',
  transition: 'border 0.24s ease-in-out 0s',
  cursor: 'pointer',
  justifyContent: 'center',
};
export const fileContainer = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
  flexDirection: 'column',
  // position: 'relative',
  width: '100%',
};
export const fileImg = {
  display: 'block',
  width: 'auto',
  borderRadius: '10px',
  height: '100%',
  background: 'white',
  objectFit: 'contain',
  position: 'relative',
};
export const fileName = {
  fontSize: '12px',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: 'inline-block',
  maxWidth: '100px',
};
export const deleteIcon = {};
export const loader = {
  position: 'absolute',
};
